import * as _ from 'lodash-es';
import {stringify as qsStringify} from 'qs';
import {SortDirection} from '../enums/sort-direction';
import {CommonListFilter, CommonListFilterQueryParams} from '../models/filters/common-list-filter';
import {FilterCriterion} from '../models/filters/filter-criterion';

export class CommonListFilterQueryParamsFactory {

    public static createQueryParams(filter: Partial<CommonListFilter>): CommonListFilterQueryParams {
        const queryParams: CommonListFilterQueryParams = {};

        if (filter.pageIndex) {
            queryParams.pageIndex = filter.pageIndex;
        }

        if (filter.pageSize) {
            queryParams.pageSize = filter.pageSize;
        }

        if (filter.sortColumn) {
            queryParams.sortColumn = filter.sortColumn;
        }

        if (filter.sortDirection) {
            queryParams.sortDirection = filter.sortDirection as SortDirection;
        }

        if (filter.pageCount) {
            queryParams.pageCount = filter.pageCount;
        }

        _.forEach(filter.filters,
            (filterCriterion: FilterCriterion) => filterCriterion.apply(queryParams)
        );

        if (queryParams.filter) {
            queryParams.filter = JSON.stringify(queryParams.filter);
        }

        return queryParams;
    }

    public static createQueryParamsAsString(filter: Partial<CommonListFilter>): string {
        const params = CommonListFilterQueryParamsFactory.createQueryParams(filter);

        return qsStringify(params, {encode: true});
    }
}
